export default __webpack_public_path__ + "static/1851-aaa155a4efb4d99f959196aca1c4b057.gif";